import { isAuthSubdomain } from '@core/config/authDomain';
import { isGroupHost } from '@core/config/groupHost';
import { isLegalHost } from '@core/config/legalHost';
import { AppProviders } from './providers';
import { AppRouter } from './router';
import { AuthApp } from './AuthApp';
import { GroupApp } from './GroupApp';
import { LegalApp } from './LegalApp';
import { ThemeTestToggle } from './ThemeTestToggle'; // TEMPORARY — remove after validation

/**
 * Root application component.
 *
 * Routes conditionally:
 * - auth.v2.meitre.com (or ?auth=1 in dev)  → AuthApp  (login/signup only)
 * - go.meitre.com (or ?group=1 in dev)      → GroupApp (tenant-less group landing)
 * - legal.meitre.com (or ?legal=1 in dev)   → LegalApp (tenant-less legal docs)
 * - {restaurant}.v2.meitre.com              → RestaurantApp (booking flow)
 */
const App = () => {
  if (isAuthSubdomain()) {
    return <AuthApp />;
  }

  if (isGroupHost()) {
    return <GroupApp />;
  }

  if (isLegalHost()) {
    return <LegalApp />;
  }

  return (
    <AppProviders>
      <AppRouter />
      <ThemeTestToggle /> {/* TEMPORARY — remove after validation */}
    </AppProviders>
  );
};

export default App;
